import { useNotifications as MUIUseNotifications, NotificationsProvider as MUINotificationsProvider, } from '@toolpad/core/useNotifications';
export const useNotifications = () => {
    const notifications = MUIUseNotifications();
    return {
        show: (message, options) => {
            notifications.show(message, Object.assign({ severity: 'info', autoHideDuration: 3000 }, options));
        },
    };
};
export const SnackbarProvider = MUINotificationsProvider;
